module.exports = require("command-line-args");